import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EstadoMultaService {
  private apiUrl =  `${environment.apiUrl}/api/estadomultas`; 
  

  constructor(private http: HttpClient) {}

  // Obtener todos los estados de multa
  getAllEstados(): Observable<any> {
    return this.http.get(this.apiUrl);
  }

  // Obtener un estado de multa por ID
  getEstadoById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }

  // Crear un nuevo estado de multa
  createEstado(estado: { descripcion: string; estado: string }): Observable<any> {
    return this.http.post(this.apiUrl, estado);
  }

  // Actualizar un estado de multa
  updateEstado(id: number, estado: { descripcion: string; estado: string }): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, estado);
  }

  // Eliminar un estado de multa
  deleteEstado(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
